export function ErrorBanner({error}:{error:unknown}){
  if(!error)return null;
  const typed=error as Error & {details?:{traceId?:string}};
  const locale=localStorage.getItem('ui-locale')==='ar'?'ar':'en';
  const message=error instanceof Error?error.message:(locale==='ar'?'فشل الطلب':'Request failed');
  const traceId=typed.details?.traceId;
  const referenceLabel=locale==='ar'?'رقم المرجع':'Reference ID';
  return <div className="error" role="alert">{message}{traceId&&traceId!=='unknown'?<div className="error-reference">{referenceLabel}: <code>{traceId}</code></div>:null}</div>;
}
